export const APP = 'pricing-pages';